export async function fetchTodoOverview(listId) {
  const suffix = listId ? `?list_id=${listId}` : "";
  const res = await fetch(`/api/todo/${suffix}`);
  const body = await res.json();
  if (!res.ok) {
    throw new Error(body?.message || "Failed to load todo overview.");
  }
  return body;
}

export async function createTodoItem(payload) {
  const res = await fetch("/api/todo/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  const body = await res.json();
  if (!res.ok) {
    throw new Error(body?.message || "Failed to create todo item.");
  }
  return body;
}

export async function updateTodoStatus(todoId, payload) {
  const res = await fetch(`/api/todo/${todoId}/status`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  const body = await res.json();
  if (!res.ok) {
    throw new Error(body?.message || "Failed to update todo status.");
  }
  return body;
}

export async function deleteTodoItem(todoId, listId) {
  const suffix = listId ? `?list_id=${listId}` : "";
  const res = await fetch(`/api/todo/${todoId}${suffix}`, {
    method: "DELETE"
  });
  const body = await res.json();
  if (!res.ok) {
    throw new Error(body?.message || "Failed to delete todo item.");
  }
  return body;
}

export async function updateTodoItem(todoId, payload) {
  const res = await fetch(`/api/todo/${todoId}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  const body = await res.json();
  if (!res.ok) {
    throw new Error(body?.message || "Failed to update todo item.");
  }
  return body;
}

export async function createTodoList(payload) {
  const res = await fetch("/api/todo/lists", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  const body = await res.json();
  if (!res.ok) {
    throw new Error(body?.message || "Failed to create todo list.");
  }
  return body;
}

export async function updateTodoList(listId, payload) {
  const res = await fetch(`/api/todo/lists/${listId}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  const body = await res.json();
  if (!res.ok) {
    throw new Error(body?.message || "Failed to update todo list.");
  }
  return body;
}

export async function archiveTodoList(listId) {
  const res = await fetch(`/api/todo/lists/${listId}/archive`, {
    method: "PATCH"
  });
  const body = await res.json();
  if (!res.ok) {
    throw new Error(body?.message || "Failed to archive todo list.");
  }
  return body;
}
